import React from 'react';
import { Commission } from '../../domain/models/Commission';
import PropTypes from 'prop-types';
import { getCommissionValue } from './getCommissionValue';

export const CommissionComponent = ({ commission }: any) => {

    return (
        <>
            <div className="w-100 d-flex flex-row align-items-center justify-content-between pt-2 pb-2 pl-4 pr-4">
                <div className="d-flex flex-column">
                    <b>{commission.carrier}</b>
                    <span>{commission.sku}</span>
                </div>
                <b>{getCommissionValue(commission)}</b>
            </div>
            <div className="dividerNoMargin"></div>
        </>
    )
}
CommissionComponent.propTypes = {
    commission: PropTypes.instanceOf(Commission).isRequired
}


